import PropTypes from "prop-types";

/**
 * This component is a wrapper to use mainly in routers to manage pages access authorizations.
 * That allow us to filter users and give access to pages only for authenticated or not authenticated user for example.
 * If the access is refused, then we allow to define an action to trigger (to make a redirection dor example).
 * By default, the user is redirect either to /login page (if he must be authenticated) or /home (if he must not be).
 * But later, we could add other kind of authorization (user groups...).
 * Note there is a second level of check which is related to other rules (and not related to authentication)
 * It can be for example the type of widget or something like that.
 * The rule and the action to do when the rule is not fulfilled is provided by props to this component.
 * At the end this filter:
 * - firstly check whether the user is allowed according to what is provided in props
 * (external context managed by the app in parent components)
 * - secondly check whether the user is authorized according to the authentication rules defined by the props
 * (internal context about whether the user is authenticated (logged in) or not).
 */
const RouteFilter = ({
  isAllowed,
  onNotAllowed,
  children,
}) => {
  if (!isAllowed && onNotAllowed) {
    return onNotAllowed();
  }

  return children;
};

RouteFilter.propTypes = {
  /**
   * Whether the route is allowed depending on external conditions.
   * This value should be true if we want the route reachable.
   * If false, by default we return error 404 not found, otherwise we return what defined by onNotAllowed.
   */
  isAllowed: PropTypes.bool,
  /**
   * The callback function to trigger when isAllowed is false.
   * It can return a JSX and/or trigger a redirection.
   */
  onNotAllowed: PropTypes.func,
  /**
   * The components to render when the authentication rules defined are fulfilled.
   */
  children: PropTypes.node,
};

RouteFilter.defaultProps = {
  isAllowed: true,
  onNotAllowed: null,
  children: null,
};

export default RouteFilter;
